import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/heart_stroke"
  }, React.createElement("path", {
    id: "Vector (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.48049C10.8419 2.55426 9.37392 2 7.77855 2C4.04205 2 1 5.0393 1 8.80463C1 12.9859 3.78242 16.487 6.25083 18.8029C7.51717 19.991 8.77762 20.939 9.71907 21.5892C10.1911 21.9152 10.5863 22.1686 10.8663 22.3422C11.0064 22.429 11.1179 22.496 11.1961 22.5423C11.2352 22.5654 11.266 22.5834 11.2878 22.596L11.3139 22.611L11.3218 22.6156L12 23L12.6756 22.6171L12.6782 22.6156L12.6861 22.611L12.7122 22.596C12.734 22.5834 12.7648 22.5654 12.8039 22.5423C12.8821 22.496 12.9936 22.429 13.1337 22.3422C13.4137 22.1686 13.8089 21.9152 14.2809 21.5892C15.2224 20.939 16.4828 19.991 17.7492 18.8029C20.2176 16.487 23 12.9859 23 8.80463C23 5.0393 19.9579 2 16.2215 2C14.6261 2 13.1581 2.55426 12 3.48049ZM12 20.8738C12.0502 20.8434 12.1083 20.8079 12.1735 20.7675C12.4311 20.6078 12.8007 20.3709 13.2449 20.0641C14.1342 19.4499 15.3182 18.5587 16.5003 17.4497C18.8862 15.2112 21.1667 12.1766 21.1667 8.80463C21.1667 6.07045 18.9556 3.84853 16.2215 3.84853C15.054 3.84853 13.9847 4.25263 13.1393 4.92872L12 5.83995L10.8607 4.92872C10.0153 4.25263 8.94597 3.84853 7.77855 3.84853C5.04439 3.84853 2.83333 6.07045 2.83333 8.80463C2.83333 12.1766 5.11384 15.2112 7.49972 17.4497C8.68178 18.5587 9.8658 19.4499 10.7551 20.0641C11.1993 20.3709 11.5689 20.6078 11.8265 20.7675C11.8917 20.8079 11.9498 20.8434 12 20.8738Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { HeartStroke24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var HeartStroke24 = createIcon(IconComponent);